import createVanilla, { StateCreator } from "zustand/vanilla";
import create from "zustand";
import { persist, PersistOptions } from "zustand/middleware";

interface WhatsNewState {
  hasDismissedServiceLinesIntro: boolean;
  dismiss: () => void;
  reset: () => void;
}

type WhatsNewPersist = (
  config: StateCreator<WhatsNewState>,
  options: PersistOptions<WhatsNewState>
) => StateCreator<WhatsNewState>;

const initialState = {
  hasDismissedServiceLinesIntro: false,
};

const store = createVanilla<WhatsNewState>(
  (persist as unknown as WhatsNewPersist)(
    (set) => ({
      ...initialState,
      dismiss: () => set({ hasDismissedServiceLinesIntro: true }),
      reset: () => set(initialState),
    }),
    {
      name: "whats-new-state-v1",
      getStorage: () => localStorage,
    }
  )
);

export { store };
export default create(store);
